import Vue from 'vue';
import Vuex from 'vuex';
import upload from '@/store/upload';
import download from '@/store/download';
import account from '@/store/account';
import admin from '@/store/admin';
import Bowser from "bowser";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        showFileDragActive: false,
        serviceWorkerIsSupported: checkServiceWorker(),
        serviceWorkerIsRegistered: false,
    },
    mutations: {
        setFileDragActive(state) {
            state.showFileDragActive = true;
        },

        setFileDragInactive(state) {
            state.showFileDragActive = false;
        },

        setServiceWorkerRegistered(state) {
            state.serviceWorkerIsRegistered = true;
        },
    },
    modules: {
        upload,
        download,
        account,
        admin,
    },
});

function checkServiceWorker(): boolean {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return ('serviceWorker' in navigator);
}
